var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "loading-screen",
      class: _vm.classes,
      style: { backgroundColor: _vm.bc },
    },
    [
      _vm.customLoader
        ? _c(_vm.customLoader, { tag: "component" })
        : _c("div", [
            _c("div", { staticClass: "loading-circle" }),
            _vm._v(" "),
            _c("p", { staticClass: "loading-text" }, [
              _vm._v(_vm._s(_vm.text)),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }